<template>
  <!--begin::Content wrapper-->
  <div
    :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
    class="modal fade forgetpassword-modal qbank-section"
    id="changemode-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            {{ $t("qbank.change_type.title") }}
          </h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> {{ $t("qbank.note.close") }}
          </button>
        </div>
        <div class="modal-body">
          <h4 class="mb-2 text-center support-text">
            <div class="mb-2">{{ $t("qbank.change_type.subtitle") }}</div>
            <br />
          </h4>

          <form @submit.prevent="handleSubmit" class="form-horizontal">
            <div class="row" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
              <input type="hidden" id="qbankId" />
              <div class="col-md-12">
                <label class="form-label fw-bold mb-3">{{
                  $t("qbank.change_type.select_type")
                }}</label>
                <div
                  class="btn-group w-100"
                  role="group"
                  aria-label="Quiz Type"
                >
                  <input
                    type="radio"
                    class="btn-check"
                    name="qtype"
                    id="typeTutor"
                    value="tutor"
                    v-model="qtype"
                    autocomplete="off"
                  />
                  <label
                    style="border: 1px solid #ddd"
                    class="btn btn-outline-primary"
                    for="typeTutor"
                  >
                    {{ $t("qbank.change_type.study_mode") }}</label
                  >

                  <input
                    type="radio"
                    class="btn-check"
                    name="qtype"
                    id="typeTimed"
                    value="timed"
                    v-model="qtype"
                    autocomplete="off"
                  />
                  <label
                    style="border: 1px solid #ddd"
                    class="btn btn-outline-primary"
                    for="typeTimed"
                  >
                    {{ $t("qbank.change_type.exam_mode") }}</label
                  >
                </div>
              </div>
            </div>

            <hr />

            <div
              class="text-end d-flex justify-content-between align-items-center mt-4"
            >
              <button
                type="button"
                class="btn btn-outline-secondary rounded-pill px-4"
                data-bs-dismiss="modal"
              >
                <i class="fa fa-arrow-right me-2"></i>
                {{ $t("qbank.note.back") }}
              </button>
              <button
                class="btn btn-success rounded-pill px-4 d-flex align-items-center"
                type="submit"
                :disabled="isLoading"
              >
                <i class="fa fa-check me-2"></i>
                {{ $t("qbank.change_type.edit") }}
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm ms-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure

export default {
  name: "ChangeType",
  emits: ["type-updated"],
  data() {
    return {
      token: localStorage.getItem("access_token"),
      code: "",
      isLoading: false,
      qtype: "", // تأكد إن عندك qtype لربط v-model
    };
  },
  methods: {
    handleSubmit() {
      this.changeType();
    },
    async changeType() {
      let questionBank = document.getElementById("qbankId").value;
      try {
        const result = await Swal.fire({
          title: this.$t("qbank.note.confirm_operation"),
          text: " ",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3ddc97",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: this.$t("qbank.note.no"),
          confirmButtonText: this.$t("qbank.note.yes"),
        });

        if (result.isConfirmed) {
          this.isLoading = true;
          let questionBank = document.getElementById("qbankId").value;
          const response = await fetch(`${apiUrl}/qbanks/${questionBank}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
            body: JSON.stringify({ quiz_mode: this.qtype, _method: "PUT" }),
          });

          if (!response.ok) {
            const errorResponse = await response.json();
            throw errorResponse;
          }

          this.isLoading = false;
          // إغلاق المودال
          const modal = bootstrap.Modal.getInstance(
            document.getElementById("changemode-modal")
          );
          if (modal) {
            modal.hide();
          }

          // إرسال event للـ parent لتحديث البيانات
          this.$emit("type-updated");

          Swal.fire({
            icon: "success",
            title: this.$t("qbank.change_type.updated_successfully"),
            text: "",
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            // تحديث الصفحة لضمان مزامنة البيانات
            location.reload();
          });
        }
      } catch (error) {
        console.error(error);
        this.isLoading = false;
        Swal.fire(
          this.$t("qbank.note.error"),
          this.$t("qbank.note.error_message"),
          "error"
        );
      }
    },
    changeMode(questionBank) {
      const input = document.getElementById("qbankId");
      if (input) {
        input.value = questionBank.id;
      }
    },
  },
};
</script>

<style scoped>
.btn-charge {
  padding: 10px 50px;
  font-weight: 600;
  background: rgb(0, 196, 68);
  border: none;
}

.btn-success {
  background-color: #00c444;
  border-color: #00c444;
  transition: 0.3s;
}

.btn-success:hover {
  background-color: #00a03b;
  border-color: #009334;
}

.btn-outline-secondary {
  border: 2px solid #ced4da;
  color: #495057;
  background-color: white;
  transition: 0.3s;
}

.btn-outline-secondary:hover {
  background-color: #f8f9fa;
  color: #212529;
  border-color: #adb5bd;
}

.btn-check:checked + .btn {
  background-color: #00c444;
  color: #fff;
  border-color: #00c444;
}

.btn-outline-primary {
  padding: 10px;
  font-weight: 500;
  transition: all 0.3s ease-in-out;
}
</style>
